const calculateTotalAmount = (items) => {
  return items.reduce((sum, item) => sum + Number(item.amount), 0);
};

const calculateTotalQuantity = (items) => {
  return items.reduce((sum, item) => sum + item.quantity, 0);
};

export const printSelectedRows = (selectedRowsData, userCompany, userImage) => {
  const printWindow = window.open('', '_blank');

  printWindow.document.write('<html><head><title>Expenses Bill</title>');
  printWindow.document.write('<style>');
  printWindow.document.write(`
    body { 
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
      margin: 20px; 
      color: #333; 
      background-color: #fafafa;
    }
    p { 
      margin: 10px 0; 
      padding: 5px; 
      text-align: left;
    }
    h1 {
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      color: black;
      margin-bottom: 5px;
      text-transform: uppercase;
    }
      h2 {
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      color:rgb(49, 49, 49);
      margin-bottom: 10px;
    }
    hr {
      margin-top: 10px;
      border: 1px solid rgb(49, 49, 49);
    }
    .total-row { 
      font-weight: bold; 
      background-color: #e8f5e9; 
    }
    .items-table {
      width: 100%; 
      border-collapse: collapse; 
      margin-bottom: 20px; 
    }
    .items-table th, .items-table td { 
      border: 1px solid #ddd; 
      padding: 12px 15px; 
      text-align: left; 
    }
    .items-table th { 
      background-color: #4CAF50; 
      color: white; 
      font-weight: bold; 
      text-transform: uppercase;
    }
    .items-table tr:nth-child(even) { 
      background-color: #f2f2f2; 
    }
    .items-table tr:hover { 
      background-color: #e6f7ff; 
      cursor: pointer; 
    }
  `);
  printWindow.document.write('</style>');
  printWindow.document.write('</head><body>');

  // Add the title "Expenses Bill" at the top
      printWindow.document.write(`<div><img src=${`https://admin.bizstor.lk/storage/app/public/images/${userImage}`} alt="Company Logo" style="max-width: 100px; margin-bottom: 15px;"></div>`);
    printWindow.document.write(`<h1>${userCompany}</h1>`);
  printWindow.document.write('<h2>Payment Reciept</h2>');
  // Add a horizontal line under the title
  printWindow.document.write('<hr>');

  // Add the selected expense details using <p> tags
  selectedRowsData.forEach((row) => {
    printWindow.document.write(`<p><strong>Full Name:</strong> ${row.fullname}</p>`);
    printWindow.document.write(`<p><strong>Reciept No:</strong> ${row.pay_id}</p>`);
    printWindow.document.write(`<p><strong>Total Amount:</strong> Rs.${calculateTotalAmount(row.items).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>`);
    printWindow.document.write(`<p><strong>Payment Type:</strong> ${row.paymenttype}</p>`);
    printWindow.document.write(`<p><strong>Date:</strong> ${row.date}</p>`);

    // Add a row for items header
    printWindow.document.write('<p><strong>Items Details:</strong></p>');

    // Add a nested table for items within each expense
    printWindow.document.write('<table class="items-table">');
    printWindow.document.write('<thead>');
    printWindow.document.write('<tr><th>Category</th><th>Amount</th></tr>');
    printWindow.document.write('</thead>');
    printWindow.document.write('<tbody>');

    row.items.forEach(item => {
      printWindow.document.write('<tr>');
      printWindow.document.write(`<td>${item.category}</td>`);
      printWindow.document.write(`<td>Rs.${Number(item.amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>`);
      printWindow.document.write('</tr>');
    });

    // Add a row to display the total amount for each expense
    printWindow.document.write('<tr class="total-row">');
    printWindow.document.write('<td colspan="1">Total</td>');
    printWindow.document.write(`<td colspan="1">Rs.${calculateTotalAmount(row.items).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>`);
    printWindow.document.write('</tr>');

    printWindow.document.write('</tbody>');
    printWindow.document.write('</table>');
  });

  printWindow.document.write('</body></html>');

  // Print and close the window
  printWindow.document.close();
  printWindow.print();
  printWindow.close();

  setTimeout(() => {
            printWindow.print();
        }, 2000);
};
